import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(ICartItemV2) {
    (function(Type) {
        Type["TYPE_UNKNOWN"] = "TYPE_UNKNOWN";
        Type["SINGLE_PRODUCT"] = "SINGLE_PRODUCT";
        Type["PREPACK"] = "PREPACK";
        Type["OPEN_SIZING"] = "OPEN_SIZING";
        Type["DISPLAY"] = "DISPLAY";
    })(ICartItemV2.Type || (ICartItemV2.Type = {}));
    ICartItemV2.build = function(partial) {
        return _object_spread({
            customizations: [],
            issues: [],
            associated_cart_item_tokens: [],
            brand_codes: [],
            settings_to_assign_on_view: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(ICartItemV2 || (ICartItemV2 = {}));
export var ICartItemV2;
